import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class Faq extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return  <section className="faq-one">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 d-flex">
                  <div className="">
                    <img src={publicUrl+"assets/images/resources/faq-new-1.jpg"} alt={ imagealt } />
                    {/*<div className="cta-three__image">*/}
                    {/*  <img src={publicUrl+"assets/images/resources/faq-new-1.jpg"} alt={ imagealt } className="cta-three__image-shape" />*/}

                    {/*</div>*/}
                    {/* /.cta-three__image */}
                  </div>{/* /.my-auto */}
                </div>{/* /.col-lg-6 */}
                <div className="col-lg-6">
                  <div className="faq-one__block">
                    <div className="block-title-two text-left">
                      <h3>Frequently Asked <br /> Questions</h3>
                    </div>{/* /.block-title-two */}
                    <div className="accrodion-grp" data-grp-name="faq-one-accrodion">
                      <div className="accrodion active">
                        <div className="accrodion-title">
                          <h4>What does the platform do?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>It enables businesses to automate customer conversations, respond to inquiries in real time, qualify prospects, and guide visitors toward the right next step using your business information and defined conversation flows.</p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                      <div className="accrodion ">
                        <div className="accrodion-title">
                          <h4>Can it capture and qualify leads?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>Yes. It can collect customer details, identify potential buying intent, and qualify prospects based on your predefined criteria, helping your team focus on the opportunities most likely to convert.</p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                      <div className="accrodion">
                        <div className="accrodion-title">
                          <h4>Where can it be integrated?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>It can be connected across the channels your customers already use, including:</p>
                            <p>Business websites</p>
                            <p>Social messaging platforms</p>
                            <p>CRM systems such as HubSpot</p>
                            <p>Supported business tools and workflows</p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                      <div className="accrodion">
                        <div className="accrodion-title">
                          <h4>How does it understand my business?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>You provide relevant business information such as FAQs, services, products, policies, and conversation guidelines. This information helps deliver responses that are relevant, consistent, and aligned with your brand.</p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                      <div className="accrodion">
                        <div className="accrodion-title">
                          <h4>Does it support real-time conversations?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>Yes. Customers receive immediate responses, allowing conversations to continue naturally without unnecessary delays.</p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                      <div className="accrodion">
                        <div className="accrodion-title">
                          <h4>Can I customize the experience?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>Yes. Businesses can configure:</p>
                            <p>Conversation flows</p>
                            <p>Brand tone and communication style</p>
                            <p>Lead qualification criteria</p>
                            <p>Questions and information collected</p>
                            <p>Responses based on specific business requirements</p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                      <div className="accrodion">
                        <div className="accrodion-title">
                          <h4>Is technical knowledge required?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>No. The platform is designed for straightforward setup and management, so you can configure your customer engagement experience without extensive technical expertise.</p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                      <div className="accrodion">
                        <div className="accrodion-title">
                          <h4>How can it improve conversions?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>By engaging visitors when their interest is highest, answering questions, identifying intent, and guiding prospects toward relevant actions, it helps reduce missed opportunities and move qualified leads further through the customer journey.</p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                      <div className="accrodion">
                        <div className="accrodion-title">
                          <h4>Is my business data secure?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>Security is an important part of the platform. Industry-standard practices are followed to help protect business and customer information.</p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                      <div className="accrodion">
                        <div className="accrodion-title">
                          <h4>Can it replace human support?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>It is designed to support your team, not replace it. Routine inquiries, initial qualification, and repetitive conversations can be automated, while complex or high-value interactions can be handed over to your team.</p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                      <div className="accrodion">
                        <div className="accrodion-title">
                          <h4>Do you provide setup and onboarding support?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>Yes. Our team can assist with setup, integrations, configuration, and onboarding to help ensure a smooth launch.
                            </p>
                          </div>{/* /.inner */}
                        </div>
                      </div>

                      <div className="accrodion">
                        <div className="accrodion-title">
                          <h4>Still Have Questions?</h4>
                        </div>
                        <div className="accrodion-content">
                          <div className="inner">
                            <p>We're here to help. Talk to our team and discover how intelligent conversations can help your business engage, qualify, and convert more customers.
                            </p>
                          </div>{/* /.inner */}
                        </div>
                      </div>
                    </div>
                  </div>{/* /.faq-one__block */}
                </div>{/* /.col-lg-6 */}
              </div>{/* /.row */}
            </div>{/* /.container */}
          </section>
        }
}

export default Faq